export default "{\n    \"label\": \"Instalación\"\n}\n"